



























































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { FormState } from '@/components/prine/enums/FormState';
import DetailedConfirmModal from '@/components/prine/DetailedConfirmModal.vue';

import type { User } from '@/models/user';
import { topicWebservice } from '@/webservices/topic';
import { conceptWebservice } from '@/webservices/concept';
import type { Topic } from '@/models/topic';
import type { Concept } from '@/models/concept';
import PrineButton from '@/components/prine/PrineButton.vue';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'StoreUpdateTopic',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {
        DetailedConfirmModal,
        PrineButton,
    },
})
export default class StoreUpdateTopic extends Vue {
    public FormState = FormState;

    // Data
    protected disabled: boolean = false;
    protected errorMsg: string = '';
    protected isConfirmModalActive: boolean = false;
    protected state: FormState = FormState.New;

    protected topic: Topic = {} as Topic;
    protected concept: Concept = {} as Concept;

    protected isConcept: boolean = false;

    protected loading = {
        data: false,
        color: '#fdc05d',
        size: '40px',
    };

    protected affectedData: Map<string, number> = new Map();

    @Getter('account/userInfo') private userInfo: User;

    // Mounted is called initially
    private async mounted() {
        if (this.$route.query.hasOwnProperty('topicId')) {
            this.load(this.$route.query.topicId.toString());
            this.state = FormState.Update;

            // Fetch the corresponding concept
            try {
                this.concept = await conceptWebservice.getByTopicId(Number(this.$route.query.topicId));
                this.isConcept = true;
            } catch (error) {
                // Not found or server error
                // Initialize the concept with the topic title as default
                this.concept.title = this.topic.title;
            }
        }
    }

    private load(topicId: string) {
        this.loading.data = true;
        topicWebservice.getById(topicId).then((response) => {
            this.topic = response.data;
            this.loading.data = false;
            this.affectedData.set(this.$tc('keywords.lesson', 2).toString(), this.topic.lessons_count);
        });
    }

    private async save() {
        this.disabled = true;
        if (!this.validate()) {
            this.disabled = false;
            return 0;
        }

        if (this.state === FormState.New) {
            topicWebservice
                .store(this.topic)
                .then(async (response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.store.topic').toString(),
                        type: 'is-success',
                    });

                    if (this.concept && this.concept.title !== '') {
                        // Fetch the topic id and store it
                        this.concept.topic_id = response.data;
                        await conceptWebservice.store(this.concept);
                    }

                    await this.$router.push({ path: '/knowledge/topics' });
                    this.$emit('syncKnowledge');
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        } else if (this.state === FormState.Update) {
            topicWebservice
                .update(this.topic)
                .then(async (response) => {
                    this.$buefy.toast.open({
                        duration: 3000,
                        message: this.$t('toastMessages.update.topic').toString(),
                        type: 'is-success',
                    });

                    if (this.isConcept && this.concept.hasOwnProperty('id')) {
                        // The concept does already exist, update it
                        this.concept.topic_id = this.topic.id;
                        await conceptWebservice.update(this.concept);
                    } else if (this.isConcept && !this.concept.hasOwnProperty('id')) {
                        if (this.concept && this.concept.title !== '') {
                            // The concept does NOT yet exist, create it
                            this.concept.topic_id = this.topic.id;
                            const conceptStoreResponse = await conceptWebservice.store(this.concept);
                            this.concept = conceptStoreResponse.data;
                        }
                    } else if (!this.isConcept && this.concept.hasOwnProperty('id')) {
                        await conceptWebservice.remove(this.concept);
                    }

                    this.$emit('syncKnowledge');
                    this.disabled = false;
                })
                .catch((error) => {
                    this.disabled = false;
                    console.log(error);
                });
        }
    }

    private toggleConfirmModal(answer) {
        this.isConfirmModalActive = !this.isConfirmModalActive;
        if (answer === true) {
            this.remove();
        }
    }

    private async remove() {
        if (this.concept && this.concept.hasOwnProperty('id')) {
            await conceptWebservice.remove(this.concept);
        }

        topicWebservice
            .remove(this.topic)
            .then((response) => {
                this.$buefy.toast.open({
                    duration: 3000,
                    message: this.$t('toastMessages.delete.topic').toString(),
                    type: 'is-success',
                });
                this.$router.push({ path: '/knowledge/topics' });
                this.$emit('syncKnowledge');
            })
            .catch((error) => {
                console.log(error);
            });
    }

    private validate() {
        if (!this.topic.title || this.topic.title === '') {
            this.errorMsg = 'title';
            return 0;
        } else {
            return true;
        }
    }
}
